//import { signin, me } from '@app/api/bible'
const bible_api = require('@/api/bible')
const ticket_api = require('@/api/ticket')
//import { signin, me } from '@app/api/data'
import { getToken, setToken, removeToken } from '@/utils/data'
import store from '@/store'
import jQuery from 'jquery'
import moment from 'moment'
import { pushHistory, parseHistory, } from '@/utils/history'

const data = {
  state: {
    info: {
      bibles: [],
    },
    index: {
      // bibles.code (SI, JC, NI, ES)
      bible: 'SI',

      // books.code (GEN, EXO, ...)
      book: 'GEN',

      // chapters.order (0, 1, 2, ...)
      chapter: 0,

      // verses.order (0, 1, 2, ...)
      verse: 0,

      // subtitle's text or ...
      other: null,
    },
    search: {
      bookCode: '',
    },
    ticket: {
      year: new Date().getFullYear(),
    },
    current: {
      bible: {
      },
      book: {
      },
      chapter: {
        html: '',
        verses: [],
        notes: [],
      },
      verse: {
      },
    },
    scroll: {
      text: null,
      updated_at: null,
    },
  },

  mutations: {
    SET_INDEX: (state, indexes) => {
      for (let key in indexes) {
        if ([ 'chapter', 'verse', ].indexOf(key) !== -1) {
          state.index[key] = parseInt(indexes[key])
        } else if ([ 'bible', 'book', ].indexOf(key) !== -1) {
          state.index[key] = indexes[key]
        } else if ([ 'other', ].indexOf(key) !== -1) {
          state.index[key] = indexes[key]
        }
      }

      if (indexes.pushHistory !== false) {
        pushHistory(state.index)
      }

      // current
      for (let i = 0; i < state.info.bibles.length; i++) {
        if (state.index.bible === state.info.bibles[i].code) {
          state.current.bible = state.info.bibles[i]
          break
        }
      }
      for (let i = 0; i < state.current.bible.bible_books.length; i++) {
        if (state.index.book === state.current.bible.bible_books[i].code) {
          state.current.book = state.current.bible.bible_books[i]
          break
        }
      }
      for (let i = 0; i < state.current.chapter.verses.length; i++) {
        if (state.index.verse === state.current.chapter.verses[i].order) {
          state.current.verse = state.current.chapter.verses[i]
          break
        }
      }
    },

    SET_SCROLL: (state, indexes) => {
      for (let key in indexes) {
        state.scroll[key] = indexes[key]
      }
      state.scroll.updated_at = moment().valueOf()
    },

    SET_BIBLES: (state, bibles) => {
      state.info.bibles = bibles
    },

    SET_CHAPTER: (state, chapter) => {
      if (chapter) {
        state.current.chapter = chapter
      } else {
        state.current.chapter = {
          html: '',
          verses: [],
          notes: [],
          overview: '',
        }
      }
    },

    SET_CHAPTER_REFERENCE: (state, chapter) => {
      const $html = jQuery(state.current.chapter.html)

      const $notes = $html.find('SPAN.book-name,P.s,P.d,SPAN.x,SPAN.f,SPAN.alt')
      let notes = []
      let alts = []
      let documents = []
      let target_s = '';
      for (let i = 0; i < $notes.length; i++) {
        let $note = jQuery($notes[i])
        let node = $note.attr('class')
        switch (node) {
          case 'book-name':
          case 's':
          case 'd':
            target_s = $note.html()
            break
//          case 'alt':
//            target_s = $note.html()
//            break
          default:
            let target = $note.attr('target') || target_s;
            let targetHtml = $note.attr('target') ? $note.attr('target') + '節' : target_s;
            if (node === 'alt') {
                alts.push({
                  target: target,
                  targetHtml: targetHtml,
                  value: $note.attr('value').replace(/&quote;/g, '"'),
                  index: $note.attr('code'),
//                  index: node === 'x' ? String.fromCharCode(9311 + parseInt($note.text()))  : $note.text(),
                  node: node,
                  break: alts.length === 0 || (alts[alts.length - 1].target != target),
                })
            } else {
                notes.push({
                  target: target,
                  targetHtml: targetHtml,
                  value: $note.attr('value').replace(/&quote;/g, '"'),
                  index: node === 'x' ? String.fromCharCode(9311 + parseInt($note.text()))  : $note.text(),
                  node: node,
                  break: notes.length === 0 || (notes[notes.length - 1].target != target),
                })
            }
            break
        }
      }
      state.current.chapter.notes = notes
      state.current.chapter.alts = alts

      state.current.verse = state.current.chapter.verses[state.index.verse]

      for (let i = 0; i < state.current.chapter.documents.study.length; i++) {
        const verse_code = state.current.chapter.documents.study[i].verse_code
        let $study_target = null

        if (verse_code === '') {
          $study_target = $html.find('.c-number > a.other')
          if ($study_target.find('span.study').length) {
            continue;
          }
          $study_target.html($study_target.html() + '<span class="study" style="font-size: calc(1em / 1.8);"></span>')
        } else {
          $study_target = $html.find('a.v[index="'+verse_code+'"]:last')
          if ($study_target.find('span.study').length) {
            continue;
          }
          $study_target.html($study_target.html() + '<span class="study"></span>')
        }
      }

      state.current.chapter.html = $html.prop('outerHTML')
    },

    SET_BIBLE_SEARCH_BOOK_CODE: function (state, value) {
      for (let i = 0; i < this.getters.bible_search_options.length; i++) {
        if (value === this.getters.bible_search_options[i].value) {
          state.search.bookCode = this.getters.bible_search_options[i].value
          return
        }
      }
      state.search.bookCode = this.getters.bible_search_options[0].value
    },

    SET_TICKET_YEAR: function (state, value) {
      state.ticket.year = value
    },
  },

  actions: {
    dataSetIndexDefault({ commit, state }) {
      let indexes = {
        bible: 'SI',
        book: 'GEN',
        chapter: 0,
        verse: 0,
      }
      commit('SET_INDEX', indexes)
    },

    dataSetIndex({ commit, state }, { indexes, updateScroll }) {
      commit('SET_INDEX', indexes)
      if (updateScroll) {
        commit('SET_SCROLL', {
          text: state.index.verse,
        })
      }
    },

    dataSetScroll({ commit, state }, indexes) {
      commit('SET_SCROLL', indexes)
    },

    dataSetChapter({ commit, state }, chapter) {
      commit('SET_CHAPTER', chapter)
      commit('SET_CHAPTER_REFERENCE')
    },

    dataNextChapter({ commit, state }) {
      state.index.chapter++
      if (state.index.chapter >= state.current.book.chapters.length) {
        state.index.chapter = 0
        let index = state.current.bible.bible_books.findIndex((item) => { return item.code === state.current.book.code })
        index = index < state.current.bible.bible_books.length - 1 ? index + 1 : 0
        if (!store.state.setting.apocrypha.value) {
          while (state.current.bible.bible_books[index].type === 'apo') {
            index = index < state.current.bible.bible_books.length - 1 ? index + 1 : 0
          }
        }
        state.index.book = state.current.bible.bible_books[index].code
      }
      state.index.verse = 0
      this.commit('SET_INDEX', [])

      commit('SET_CHAPTER_REFERENCE')
      commit('SET_SCROLL', {
        text: state.index.verse,
      })
    },

    dataPrevChapter({ commit, state }) {
      state.index.chapter--
      if (state.index.chapter < 0) {
        let index = state.current.bible.bible_books.findIndex((item) => { return item.code === state.current.book.code })
        index = index > 0 ? index - 1 : state.current.bible.bible_books.length - 1
        if (!store.state.setting.apocrypha.value) {
          while (state.current.bible.bible_books[index].type === 'apo') {
            index = index > 0 ? index - 1 : state.current.bible.bible_books.length - 1
          }
        }
        state.index.book = state.current.bible.bible_books[index].code
        state.index.chapter = state.current.bible.bible_books[index].chapters.length - 1
      }
      state.index.verse = 0
      this.commit('SET_INDEX', [])

      commit('SET_CHAPTER_REFERENCE')
      commit('SET_SCROLL', {
        text: state.index.verse,
      })
    },

    dataBibleIndex({ commit, state }, bibleCode) {
      return new Promise((resolve, reject) => {
        bible_api.index(bibleCode).then(response => {
          const data = response.data
          commit('SET_BIBLES', data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleChapterCurrent({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_CHAPTER', null)

        store.dispatch(
          'dataBibleChapter',
          {
            bibleCode: state.index.bible,
            bookCode: state.index.book,
            chapterOrder: state.index.chapter,
            update: true,
          }
        ).then((response) => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleChapter({ commit, state }, { bibleCode, bookCode, chapterOrder, update }) {
      if (store.state.auth.ticket === 'basic') {
        bibleCode = 'SI'
      }
      return new Promise((resolve, reject) => {
        bible_api.chapter(bibleCode, bookCode, chapterOrder).then(response => {
          const data = response.data
          if (update) {
            store.dispatch('dataSetChapter', data)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleVerse({ commit, state }, { bible, book, chapter, verse}) {
      return new Promise((resolve, reject) => {
        bible_api.verse(bible, book, chapter, verse).then(response => {
          const data = response.data
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleLastVerse({ commit, state }, { bible, book}) {
      return new Promise((resolve, reject) => {
        bible_api.last_verse(bible, book).then(response => {
          const data = response.data
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleOpenWithIndex({ commit, state }, indexes) {
      if (state.current.bible.code === indexes.bible
          && state.current.book.code === indexes.book
          && state.current.chapter.code === indexes.chapter
          ) {
          return new Promise((resolve, reject) => {
            store.dispatch('dataSetIndex', {
              indexes: indexes.pushHistory === true ? indexes : Object.assign(indexes, { pushHistory: false, }),
              updateScroll: true,
            })
          })
      }

      commit('SET_CHAPTER', null)

      return new Promise((resolve, reject) => {
        store.dispatch(
          'dataBibleChapter',
          {
            bibleCode: indexes.bible,
            bookCode: indexes.book,
            chapterOrder: indexes.chapter,
          }
        ).then(response => {
          const data = response.data
          store.dispatch('dataSetIndex', {
            indexes: indexes.pushHistory === true ? indexes : Object.assign(indexes, { pushHistory: false, }),
            updateScroll: true,
          }).then(response => {
            store.dispatch('dataSetChapter', data)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataBibleSearch({ commit, state }, { bibleCode, bookCode, keyword, skip }) {
      return new Promise((resolve, reject) => {
        bible_api.search(bibleCode, bookCode, keyword, skip).then(response => {
          const data = response.data
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataTicketSearch({ commit, state }, date) {
      return new Promise((resolve, reject) => {
        ticket_api.search(date).then(response => {
          const data = response.data
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    dataSetBibleSearchBookCode({ commit, state }, value) {
      commit('SET_BIBLE_SEARCH_BOOK_CODE', value)
    },

    dataSetTicketYear({ commit, state }, value) {
      commit('SET_TICKET_YEAR', value)
    },
  }
}

export default data
